import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { FileExtension } from '@/components/ui/Image/SvgImage/FileExtension';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * ファイルアップロード：表示テキスト部分
 * @param props
 * @constructor
 */
export const UploadFileText = (props) => {
    const { className = '', disabled = false, fileName = '', textSize = 'xs', } = props;
    /** ファイルの拡張子 */
    const fileExtension = useMemo(() => fileName.split('.').pop() || '', [fileName]);
    return (_jsxs(IconTextGroup, Object.assign({ className: className }, { children: [_jsx(FileExtension, { extension: fileExtension, size: 'md' }), _jsx(Text, Object.assign({ className: clsx(!disabled && 'underline', 'break-all'), color: disabled ? 'inactive' : 'link', size: textSize, tagName: 'span' }, { children: fileName }))] })));
};
